import styles from "./index.css";
import Proptypes from "prop-types";

const InitialisationError = ({ title, messages, Button }) => (
  <>
    <h2 className={styles.title}>{title}</h2>
    <span className={styles.messages}>
      {messages.map((message, index) => (
        <p key={index}>{message}</p>
      ))}
    </span>
    {Button ? <Button className={styles.button} /> : null}
  </>
);

InitialisationError.propTypes = {
  title: Proptypes.string.isRequired,
  messages: Proptypes.arrayOf(Proptypes.string).isRequired,
  Button: Proptypes.elementType
};

export default InitialisationError;
